<template>
    <tr>
        <td class="no_padding drag_drop"><span></span></td>
        <td class="no_padding">
          <input type="checkbox"
                 :id="log.id"
                 :value="log.id"
                 @change="onChange"
                 :checked="isChecked"
                 @click.stop
          />
          <label :for="log.id" @click.stop v-translate>Vybrat</label>
        </td>
        <td data-th="Metoda">{{ log.method }}</td>
        <td data-th="Obslouženo z">{{ log['served-by'] }}</td>
        <td data-th="Název metody" class="first_data"><strong>{{ methodDescription() }}</strong></td>
        <td data-th="Http Code"><span :class="{success_state: log.code == '200', error_state: log.code != '200'}">{{ codeDescription() }}</span></td>
        <td data-th="IP">{{ log.ip }}</td>
        <td data-th="Datum a čas" class="last_data" v-html="$_date_formatFull(log.timestamp, true, true)" />
        <td class="no_padding"></td>
    </tr>
</template>

<script>
export default {
    name: "ActivityRow",
    props: ["log", 'selectedEntities'],
    data () {
        return {
            methodDescriptionList: {
                'getAllChannels': this.$gettext('Získání všech kanálů'),
                'setChannelParentalLock': this.$gettext('Nastavení zámku kanálu'),
                'addChannelGroup': this.$gettext('Vytvoření skupiny kanálů'),
                'updateChannelGroup': this.$gettext('Změna skupiny kanálů'),
                'deleteChannelGroup': this.$gettext('Smazání skupiny kanálů'),
                'resetSystemChannelGroupOrder': this.$gettext('Reset řazení systémové skupiny kanálů'),
                'getAllChannelGroups': this.$gettext('Získání všech skupin kanálů'),
                'getDeviceScreen': this.$gettext('Získání obrazovek zařízení'),
                'getDevices': this.$gettext('Získání seznamu zařízení'),
                'logDeviceStart': this.$gettext('Zalogování startu zařízení'),
                'getSettings': this.$gettext('Získání nastavení'),
                'isPinCorrect': this.$gettext('Ověření platnosti PIN'),
                'getSelfServiceGroups': this.$gettext('Získání nabídky samoobsluhy'),
                'updateSelfServiceStatus': this.$gettext('Změna položky samoobsluhy'),
                'checkDeviceTokenValidity': this.$gettext('Ověření platnosti device tokenu'),
                'getAllStreamProfiles': this.$gettext('Získání všech stream profilů'),
                'addPvr': this.$gettext('Vytvoření nahrávky'),
                'updatePvr': this.$gettext('Změna nahrávky'),
                'deletePvr': this.$gettext('Smazání nahrávky'),
                'getAllPvrs': this.$gettext('Získání všech nahrávek'),
                'getSources': this.$gettext('Získání programové skladby'),
                'getChanges': this.$gettext('Volání změnové metody'),
                'getRestarts': this.$gettext('Získání stavu požadavků na restartování'),
                'getAllMessages': this.$gettext('Získání všech oznámení'),
                'setMessageRead': this.$gettext('Nastavení přečtení oznámení'),
                'deleteMessage': this.$gettext('Smazání zařízení'),
                'setMessageNotificationHidden': this.$gettext('Skrytí notifikace oznámení'),
                'addDashboardCarousel': this.$gettext('Vytvoření uživatelského carouselu'),
                'updateDashboardCarousel': this.$gettext('Upravení uživatelského carouselu'),
                'deleteDashboardCarousel': this.$gettext('Smazání uživatelského carouselu'),
                'getAvailableDashboardCarousels': this.$gettext('Získání dostupných uživatelských carouselů'),
                'getDashboardSettings': this.$gettext('Získání nastavení dashboardu'),
                'setDashboardSettings': this.$gettext('Nastavení dashboardu'),
                'addFavoriteShow': this.$gettext('Vytvoření oblíbeného pořadu'),
                'deleteFavoriteShow': this.$gettext('Smazání oblíbeného pořadu'),
                'getFavoriteShows': this.$gettext('Získání seznamu oblíbených pořadů'),
                'addPeriodicPvr': this.$gettext('Vytvoření pravidelné nahrávky'),
                'getAllPeriodicPvrs': this.$gettext('Získání pravidelných nahrávek'),
                'deletePeriodicPvr': this.$gettext('Smazání pravidelné nahrávky'),
                'getAdvertisingBanners': this.$gettext('Získání marketingových oznámení'),
                'deleteAdvertisingBanner': this.$gettext('Označení marketingového oznámení za smazané'),
                'setAdvertisingBannerRead': this.$gettext('Označení marketingového oznámení za přečtené'),
                'addSubscriberProfile': this.$gettext('Přidání nového uživatelského profilu'),
                'deleteSubscriberProfile': this.$gettext('Smazání uživatelského profilu'),
                'getSubscriberProfileAvailableImages': this.$gettext('Získání dostupných obrázků uživatelských profilů'),
                'getSubscriberProfiles': this.$gettext('Získání informací o uživatelských profilech'),
                'updateSubscriberProfile': this.$gettext('Upravení uživatelského profilu'),
                'isSubscriberProfilePinCorrect': this.$gettext('Zjištění platnosti uživatelského profilu'),
                'checkChallengeToken': this.$gettext('Ověření párovacího tokenu'),
                'createChallengeToken': this.$gettext('Vytvoření tokenu pro párování'),
                'getBrand': this.$gettext('Získání informací o brandu'),
                'getInitialProcessSetup': this.$gettext('Získání informací pro první spuštění'),
                'unsubscribeDevice': this.$gettext('Odpárování zařízení'),
                'getSubscriber': this.$gettext('Získání informací o odběrateli'),
                'updateSubscriber': this.$gettext('Upravení informací odběratele'),
            }
        }
    },
    computed: {
        isChecked() {
          return this.selectedEntities.indexOf(String(this.log.id)) > -1
        },
      },
    methods: {
      methodDescription() {
        return this.methodDescriptionList[this.log.method] ? this.$gettext(this.methodDescriptionList[this.log.method]) : '';
      },
      codeDescription() {
        let description = [this.log.code];

        switch(this.log.code) {
          case '200':
            description.push('OK');
            break;
          case '400':
            description.push('BAD REQUEST');
            break;
          case '403':
            description.push('FORBIDDEN');
            break;
          case '404':
            description.push('NOT FOUND');
            break;
          case '409':
            description.push('CONFLICT');
            break;
          case '500':
            description.push('INTERNAL SERVER ERROR');
            break;
        }

        return description.join(" ");
      },
      onChange: function (e) {
        this.$emit('input', e)
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/detail/ActivityRow.vue